import { action, extendObservable } from 'mobx';
import FormService from '../../../core/services/FormService';
import { isRequired } from '../../../core/validations';
import NotificationService from '../../../core/services/NotificationService';
import EmailTemplateFormService from './EmailTemplateFormService';

class EmailTemplateUploadFormService {
  form = new FormService();

  constructor() {
    extendObservable(this, {
      emailTemplateId: null,
    });
  }

  init = action(() => {
    this.form.validations = {
      locale: [isRequired],
      subject: [isRequired],
      template: this.form.getValue('id') ? [] : [isRequired],
    };
    this.form.reset();
    this.form.setInitialValues({});
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    EmailTemplateFormService.form.setValue('templates', [
      ...EmailTemplateFormService.form
        .getValue('templates')
        .filter((template) => template.locale !== this.form.getValue('locale')),
      { ...this.form.getValues() },
    ]);

    this.form.reset();
    this.form.setInitialValues({});
  });
}

const emailTemplateUploadFormService = new EmailTemplateUploadFormService();
export default emailTemplateUploadFormService;
